import { LoadingKey } from '../app-active-loading/LoadingKey';
import { handleWordpressAuthorizationError } from '../http-wordpress/handleWordpressAuthorizationResponse';
import { makeWordpressAuthorizationRequest, validateOAuthPermissions } from '../http-wordpress/wordpressAuthorization';
import { EndpointKey } from '../http/EndpointKey';
import { IntegrationsActionTypes } from '../store/integrations/action-types';
import { setWordpressPermissions } from '../store/integrations/action-creators';
import { checkIfLoggedInIfNotExistingAccount } from '../http/endpointStateChecks';
import { isSignupDataCompleted } from '../store/signup-data/selectors';
import { Data } from '../signup-data/DATA';
export const EndpointsIntegrations = {
  [EndpointKey.ValidateOAuthPermissions]: {
    reduxActionType: IntegrationsActionTypes.ValidateOAuthPermissions,
    method: validateOAuthPermissions,
    loadingKey: LoadingKey.StandardLoading,
    handleError: (error, dispatch) => dispatch(setWordpressPermissions(false)),
    handleSuccess: (_, dispatch) => dispatch(setWordpressPermissions(true))
  },
  [EndpointKey.WordpressAuthorization]: {
    stateCheck: state => {
      return isSignupDataCompleted(state, Data.WordpressRecaptchaToken) && checkIfLoggedInIfNotExistingAccount(state);
    },
    loadingKey: LoadingKey.StandardLoading,
    method: makeWordpressAuthorizationRequest,
    handleError: handleWordpressAuthorizationError,
    isStateOnlyTrigger: true,
    once: true
  }
};